module.exports = __webpack_public_path__ + "img/pageBanner-latestNews.5e176923.jpg";